import React from "react";
import PropTypes from "prop-types";
import { Box, Typography, Divider } from "@mui/material";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import SubdirectoryArrowRightIcon from "@mui/icons-material/SubdirectoryArrowRight";
import CommodityIcon from "../../../../assets/icons/CommodityIcon";
import WeightIcon from "../../../../assets/icons/WeightIcon";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import { formatCurrency, formatNumberWithCommas, formatTitleCase } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";

export default function CarrierOffersModalHeader({
  displaySidebar,
  displayMiniSidebar,
  load,
  origin,
  originDate,
  destination,
  destinationDate,
  extraStops
}) {
  return (
    <>
      {displayMiniSidebar === "block" &&
        <Box>
          <Typography variant="h2" color="black_opacity.100">
            Make Offer on #{load?.id}
          </Typography>
        </Box>
      }
      {displaySidebar === "block" &&
        <Box style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <Typography variant="h2" marginRight="20px">Make Offer on #{load?.id}</Typography>
          <Box style={{ display: "flex", alignItems: "center" }}>
            <Typography variant="body1" color="black_opacity.100">
              {`${formatTitleCase(origin?.cityName)}, ${origin?.state}`}
            </Typography>
            <ArrowForwardIcon sx={{ margin: "0 10px", fontSize: "20px" }} />
            <Typography variant="body1" color="black_opacity.100">
              {`${formatTitleCase(destination?.cityName)}, ${destination?.state}`}
            </Typography>
            {extraStops &&
              <Typography variant="subhead1" color="black_opacity.100" marginLeft="20px">
                {extraStops}
              </Typography>
            }
            <Typography variant="subhead1" color="black_opacity.100" marginLeft="20px">
              Pick Up
            </Typography>
            <Typography variant="body1" color="black_opacity.100" marginLeft="5px">
              {nullCheck(originDate, "-")}
            </Typography>
            <Typography variant="subhead1" color="black_opacity.100" marginLeft="20px">
              Drop Off
            </Typography>
            <Typography variant="body1" color="black_opacity.100" marginLeft="5px">
              {nullCheck(destinationDate, "-")}
            </Typography>
          </Box>
        </Box>
      }
      <Divider sx={{ marginY: "5px" }} />
      {displayMiniSidebar == "block" &&
        <Box style={{ display: "flex", alignItems: "center" }}>
          <Typography variant="body1" color="black_opacity.100">
            {`${formatTitleCase(origin.cityName)}, ${origin.state}`}
          </Typography>
          <ArrowForwardIcon sx={{ margin: "0 10px", fontSize: "20px" }} />
          <Typography variant="body1" color="black_opacity.100">
            {`${formatTitleCase(destination.cityName)}, ${destination.state}`}
          </Typography>
          {extraStops &&
            <StyledTooltip arrow title={load.stops.map((r, i) => {
              if (i > 0 && i < load.stops.length - 1) return (<Typography key={r.id} variant="body1" marginBottom="5px">{formatTitleCase(r.cityName)}, {r.state}</Typography>);
            })}>
              <Typography variant="body1" color="black_opacity.100" marginLeft="10px">
                {extraStops}
              </Typography>
            </StyledTooltip>
          }
        </Box>
      }
      {displaySidebar == "block" &&
        <Box sx={{
          backgroundColor: "black_solid.10",
          color: "black_solid.60",
          marginY: "5px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px"
        }}>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <LocalShippingIcon sx={{ fontSize: "15px", marginRight: "10px" }} />
            <Typography variant="body1">
              {load.equipmentTypeId !== null ? `${load.revenueCodeId} ( ${load.equipmentTypeId} )` : load.revenueCodeId}
            </Typography>
            {typeof (load.minTemp) == "number" &&
              <Typography variant="body1" marginLeft="20px">Min/Max Temp {load.minTemp} / {load.maxTemp}</Typography>
            }
          </Box>
          <Typography variant="body1">
            <CommodityIcon sx={{ fontSize: "20px", marginBottom: "-10px" }} />
            {formatTitleCase(load.commodity)}
          </Typography>
          <Typography variant="body1">
            <WeightIcon sx={{ fontSize: "15px", marginBottom: "-3px" }} />
            {formatNumberWithCommas(load.weight)} lbs
          </Typography>
          <Typography variant="body1">
            <SubdirectoryArrowRightIcon sx={{ fontSize: "15px" }} />
            {load.miles} mi
          </Typography>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            <Typography variant="subhead1" marginLeft="5px">Target pay</Typography>
            <Typography variant="body1" marginLeft="5px">{formatCurrency(load.targetPay)} /</Typography>
            <Typography variant="subhead1" marginLeft="5px">Max pay</Typography>
            <Typography variant="body1" marginLeft="5px">{formatCurrency(load.maxPay)}</Typography>
          </Box>
          {load.orderTypeId &&
            <Typography variant="body1">
              <b>TYPE</b> {load.orderTypeId}
            </Typography>
          }
        </Box>
      }
    </>
  );
}

CarrierOffersModalHeader.propTypes = {
  displaySidebar: PropTypes.string,
  displayMiniSidebar: PropTypes.string,
  load: PropTypes.object,
  origin: PropTypes.object,
  originDate: PropTypes.string,
  destination: PropTypes.object,
  destinationDate: PropTypes.string,
  extraStops: PropTypes.string
};